<template>
    <div class="flex flex-col">
        <div
            class="bg-white dark:bg-slate-100 py-8 px-12 hover:shadow-md transition-shadow dark:shadow-slate-900/50 relative rounded-lg flex items-center justify-center h-[212px]"
        >
            <div class="absolute top-3 right-3 flex items-center gap-1">
                <div
                    v-if="
                        alertsFeatureEnabled &&
                        alertsEnabledProgramIds.includes(partner.id)
                    "
                    class="relative"
                >
                    <div
                        @mouseover="showBellTooltip = true"
                        @mouseleave="showBellTooltip = false"
                        class="flex items-center justify-center"
                        aria-label="Bonus alert added"
                    >
                        <Icon
                            icon="bell-added-color"
                            class="w-5 h-5 text-slate-500 dark:text-slate-400"
                        />
                    </div>
                    <div v-show="showBellTooltip" :class="tooltipPositionClasses">
                        Bonus alert added
                    </div>
                </div>
                <div class="relative">
                    <button
                        @click.stop="$emit('toggle-favorite', partner)"
                        @mouseover="showFavTooltip = true"
                        @mouseleave="showFavTooltip = false"
                        class="flex items-center justify-center transition-colors duration-200 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:ring-offset-2 rounded"
                        aria-label="Toggle favorite"
                    >
                        <Icon
                            :icon="
                                partner.is_favorite ? 'heart' : 'unfavorited'
                            "
                            :class="[
                                'w-5 h-5 transition-colors duration-200',
                                partner.is_favorite
                                    ? 'text-red-500 hover:text-red-400'
                                    : 'text-slate-400 hover:text-orange',
                            ]"
                        />
                    </button>
                    <div
                        v-show="showFavTooltip"
                        :class="tooltipPositionClasses"
                    >
                        {{
                            partner.is_favorite
                                ? 'Remove from favorites'
                                : 'Add to favorites'
                        }}
                    </div>
                </div>
            </div>

            <div
                class="w-full h-full flex items-center justify-center cursor-pointer overflow-hidden"
                @click="$emit('navigate', partner)"
            >
                <img
                    v-if="partner.program_image && !imageError[partner.id]"
                    :src="`${cdnUrl}/${partner.program_image.path}/_small/${partner.program_image.file_name}`"
                    :alt="partner.name"
                    class="max-w-full max-h-[120px] object-contain"
                    @error="$emit('image-error', partner.id)"
                />
                <div
                    v-else
                    class="w-20 h-12 bg-gray-100 dark:bg-slate-700 border border-gray-200 dark:border-slate-700 rounded flex items-center justify-center"
                >
                    <span
                        class="text-xs font-medium text-gray-500 dark:text-gray-400 text-center px-1"
                    >
                        {{ partner.name.slice(0, 8) }}
                    </span>
                </div>
            </div>
        </div>

        <div class="mt-3">
            <h3
                class="text-slate-800 dark:text-slate-100 text-sm font-medium leading-5 mb-1 cursor-pointer hover:text-gray-400 transition-colors duration-200"
                @click="$emit('navigate', partner)"
            >
                {{ partner.name }}
            </h3>
            <p class="text-slate-500 dark:text-slate-400 text-sm font-normal leading-5">
                {{ formatProgramType(partner.type) }}
            </p>
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useAppStore } from '@/store/app';
import Icon from '@/components/ui/icon/icon.vue';

const cdnUrl = window.cdnUrl;

const props = defineProps({
    partner: { type: Object, required: true },
    index: { type: Number, required: true },
    alertsFeatureEnabled: { type: Boolean, default: false },
    alertsEnabledProgramIds: { type: Array, default: () => [] },
    imageError: { type: Object, default: () => ({}) },
    formatProgramType: { type: Function, required: true },
});

defineEmits(['toggle-favorite', 'navigate', 'image-error']);

const appStore = useAppStore();
const { sidebarOpen } = storeToRefs(appStore);

const showBellTooltip = ref(false);
const showFavTooltip = ref(false);

const tooltipPositionClasses = computed(() => {
    const position = (props.index % 4) + 1;
    const isLastColumn = position === 4;
    const base = 'hidden md:block absolute bottom-full mb-2 py-1 px-2 text-sm text-white bg-[#1E293B] rounded-lg shadow-sm whitespace-nowrap z-50';

    if (!isLastColumn) {
        return `${base} left-1/2 -translate-x-1/2`;
    }

    return sidebarOpen.value
        ? `${base} right-0`
        : `${base} left-1/2 -translate-x-1/2`;
});
</script>
